module.exports = __webpack_public_path__ + "img/SouthwickMaleSpadefoot_Kubel_20220823_MOBILE.e1f283ee.jpg";